/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ShopMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABfElEQVR4nN2UO07DQBCGDQVQUgAN4RyUtEbxPLawZlCQcgYEfTqIEFJ4NBwE0dBERAHBHehAFLxEARE0QWMSkTgxcYILYKWR5Znd/9t/1mvP+1cDUReR9BxI3pG1iSQ1ywNrPXpnbQLpGzrNDy3u3Oocsjy3hdrhGbgzh7o20u4Dko24eD9AEKzMxF0lRqsD0QDWkzQAPwxnoxxJbRAAWE8j8VKpNA6kr2kAQLo+SofGkPWl16LefgLkrvOQrZ1ExemhCMBy2OtAdlqASp/+brbclfusq/QAlorFKSQ9QJZH27mJW85qYRhOAOmu1YDlyQR835+0mj2tBqQPQHLfWUvjKkCSq4BlOV6zu2C1oe4EklSRZR9I9pD0MvZF1IF02wJJzroPXi4ih9YBkmoyYNB3zeni9wGA5CifD+fb85wr5JD0ODOAc4VcfC6RLGQG8DKa/w8AwHKTAeD6OwflnwKAdCsRYP8cg3Q5IWkkAkgaXzc9WlM2jUTAnxwfmOsAbuEKXiwAAAAASUVORK5CYII=)
 */
export const ShopMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2.63 4.19A3 3 0 0 1 5.53 2H7a1 1 0 0 1 1 1v4.03A2.95 2.95 0 0 1 5.03 10h-.05c-2 0-3.44-1.9-2.9-3.83l.55-1.98ZM10 2a1 1 0 0 0-1 1v4a3 3 0 0 0 5.7 1.33c.07-.16-.05-.34-.23-.38a3 3 0 0 1-1.02-5.52c.18-.11.14-.41-.08-.42L12 2h-2ZM16.3 8.33c-.08-.16.05-.33.22-.33h5.05c.14 0 .24.14.18.26A3.01 3.01 0 0 1 19.02 10h-.05a2.97 2.97 0 0 1-2.67-1.67Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21 11.42V19a3 3 0 0 1-3 3h-2.75a.25.25 0 0 1-.25-.25V16a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v5.75c0 .14-.11.25-.25.25H6a3 3 0 0 1-3-3v-7.58c0-.18.2-.3.37-.24a4.46 4.46 0 0 0 4.94-1.1c.1-.12.3-.12.4 0a4.49 4.49 0 0 0 6.58 0c.1-.12.3-.12.4 0a4.45 4.45 0 0 0 4.94 1.1c.17-.07.37.06.37.24ZM15 4a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        className={colorClass}
      />
    </svg>
  );
};
